import type { MessageSchema } from '@/i18n/types';

const kk: MessageSchema['calendar'] = {
    last30Days: 'Соңғы 30 күн',
    last7Days:  'Соңғы 7 күн',
    lastMonth:  'Өткен ай',
    lastWeek:   'Өткен апта',
    lastYear:   'Соңғы жыл',
    period:     'Кезең',
    thisMonth:  'Осы ай',
    thisWeek:   'Осы апта',
};

export default kk;
